import * as THREE from 'three';

export default class Particle {
	DAMPING = 0.03;
	DRAG = 1 - this.DAMPING;

    constructor(x, y, mass, restDistance, clothFunction) {
        this.position = new THREE.Vector3();
        this.previous = new THREE.Vector3();
        this.original = new THREE.Vector3();
        this.acceleration = new THREE.Vector3(0, 0, 0);
        this.invMass = 1 / mass;
        this.tmp = new THREE.Vector3();
        this.tmp2 = new THREE.Vector3();
        this.restDistance = restDistance;
        clothFunction(x, y, this.position);
        clothFunction(x, y, this.previous);
        clothFunction(x, y, this.original);
    }

    addForce(force) {
        this.acceleration.add(
            this.tmp2.copy(force).multiplyScalar(this.invMass)
        );
    }

    integrate(timesq) {
        const newPos = this.tmp.subVectors(this.position, this.previous);
        newPos.multiplyScalar(this.DRAG).add(this.position);
        newPos.add(this.acceleration.multiplyScalar(timesq));
    
        this.tmp = this.previous;
        this.previous = this.position;
        this.position = newPos;
    
        this.acceleration.set(0, 0, 0);
    }
}